import { environment } from "src/environments/environment";

export class Utils {
    static getEnv(): string {
        return environment.production ? "prod" : "dev";
    }

    static getNewUid(): string {
        return `${Date.now()}-${Math.floor(Math.random() * 10000)}-${Math.floor(Math.random() * 10000)}`;
    }
}
